// System
import { Button } from '@mui/material';
// Components
import FormProvider from '@Components/hook-form';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateProviderConfigContent } from './CreateProviderConfigContent';
// Redux
import { useCreateProviderConfig } from '@Modal/hooks/providers/useCreateProviderConfig';
// Form
import { useCreateProviderConfigForm } from '@Forms/providers/CreateProviderConfigFormContext';

export const CreateProviderConfigForm = () => {
  const methods = useCreateProviderConfigForm();
  const { handleCreateCancel, submittable, handleSubmitCreateProviderConfig } =
    useCreateProviderConfig();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <CreateProviderConfigContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleCreateCancel}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!submittable}
              onClick={handleSubmitCreateProviderConfig}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
